import type { SWRConfiguration } from 'swr';
import { toastFromError } from './utils/toast-factory';

export const createSWRConfig = (
  showToast: (msg: string, type: 'success' | 'error' | 'warning') => void
): SWRConfiguration => ({
  revalidateOnFocus: false,
  onError: (error: unknown) => toastFromError(error, showToast),
});
